export default __webpack_public_path__ + "static/media/car.d92778aa.webp";